import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'shared-master-projects-image-grid',
  templateUrl: './master-projects-image-grid.component.html',
  styleUrls: ['./master-projects-image-grid.component.scss'],
  host: { class: 'master-projects-image-grid' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedMasterProjectsImageGridComponent {
  @Input() projects!: any;
}
